import React, { useState, useRef , useEffect} from "react";
import "../Styles/approve.css";

const data = [{
    item1: "value1",
    item2: "value2",
    item3: "value3"
  }];

 


const Approval = ({ list=[], module=""}) => {
    function clickApprove(module, id, status, isEAD){
        const postBody = {
            module: module,
            id: id,
            status: status,
            isEAD: isEAD,
          };
          const requestMetadata = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postBody),
          };
          fetch("http://sfoadmin.myimpactmeter.com:5050/update/status/ngo", requestMetadata)
            .then((res) => res.json())
            .then((result) => {
                console.log(result);
            });
    }

    function closet(classn){
        if(classn == 'NGO'){
            var collection = document.getElementsByClassName("approve");
            collection[0].style.display = "none";
        }
        else if(classn == 'EDU'){
            var collection = document.getElementsByClassName("approve");
            collection[1].style.display = "none";
        }
        else{
            var collection = document.getElementsByClassName("approve");
            collection[2].style.display = "none";
        }
    }

    return(
        <div className="approve">
            <h1 style={{"font-size":"40px", "position":"fixed"}} onClick={()=>{closet(module)}} className="close">+</h1>
            <div className="list">
                <div className="items1">
                {list.map((item, index) => (
                    <div className="appro">
                    {Object.keys(item).map((key) => (
                        <p key={key}>
                        {key} = {String(item[key])} &nbsp; &nbsp; &nbsp;
                        </p>
                    ))}
                    <div className="appgree" onClick={()=>{clickApprove(module, item['id'], 'approved', true)}} > International Approve</div>
                    <div className="appgree" onClick={()=>{clickApprove(module, item['id'], 'approved', false)}} > Approve</div>
                    <div className="appdis" onClick={()=>{clickApprove(module, item['id'], 'rejected', false)}}> DisApprove</div>
                    </div>
                ))}
                   
                </div>
            </div>
        </div>
    );
  }
export default Approval;